import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_40uiyujpi6: FaireBrandEntity = {
  token: "b_40uiyujpi6",
  type: "brand",
  name: "Plushology® by RGU",
  avatarUrl:
    "https://cdn.faire.com/fastly/0167ebd349c85181ddcd16989f28afde5b508e8582676768e9ad999d5444abed.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/72334cc708b7abd895f3a5b0779f764168568a23b8ed49ae2dbad03ae452f776.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0167ebd349c85181ddcd16989f28afde5b508e8582676768e9ad999d5444abed.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72334cc708b7abd895f3a5b0779f764168568a23b8ed49ae2dbad03ae452f776.jpeg",
  location: "Winston Salem, NC, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 71,
  isTopShop: true,
  isInsider: true,
  description:
    "The plushies that sell aren’t just soft. \nThey mean something.\n\nPlushology® creates premium semi-custom and custom plush for high-traffic retail environments where storytelling, sense of place, and memorable merchandise drive sales. Designed for airports, hotels and resorts, attractions, agritourism destinations, travel plazas, and specialty gift shops, our regionally inspired, brand-aligned plush helps buyers introduce products that feel distinctive, giftable, and built to move.\n\nAt the heart of it, we help turn brands, places, and experiences into something guests can take home, hold onto, and remember. With dependable availability, strong fill rates, and concept-to-delivery in as few as 10 business days, Plushology® makes it easy to test new ideas, replenish quickly, reduce inventory risk, and scale the programs that resonate.\n\nThe right plushies don’t just sit on a shelf.\nThey go home with your guests.\n\nPlushology®\nPremium Plush. Built for Retail.\nThat's what we call Souvenir Reimagined.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.192Z",
    importedBy: "entity-db-cli",
  },
};
